export const validateOrganizer = (data, isEdit = false) => {
  const errors = {};

  if (!data.companyName?.trim()) {
    errors.companyName = "Tiltle is required";
  }

  if (!data.subTitle?.trim()) {
    errors.subTitle = "Sub Tiltle is required";
  }

  if (!data.aboutEvent?.trim()) {
    errors.aboutEvent = "About Event is required";
  }
  if (!data.eventType?.trim()) {
    errors.eventType = "Event Type is required";
  }
  // --- PRICE VALIDATION ---
  if (data.price === "" || data.price === null || data.price === undefined) {
    errors.price = "Price is required";
  } else if (isNaN(data.price) || Number(data.price) < 0) {
    errors.price = "Price must be a number and at least 0";
  }

  // --- TAX VALIDATION ---
  if (data.tax === "" || data.tax === null || data.tax === undefined) {
    errors.tax = "Tax is required";
  } else if (isNaN(data.tax)) {
    errors.tax = "Tax must be a valid number";
  } else if (Number(data.tax) < 0) {
    errors.tax = "Tax cannot be negative";
  } else if (Number(data.tax) > 25) {
    errors.tax = "Tax cannot exceed 20%";
  }
  if (!data.companyEmail?.trim()) {
    errors.companyEmail = "Organizer email is required";
  } else if (
    !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(data.companyEmail)
  ) {
    errors.companyEmail = "Invalid company email";
  }

  if (!data.companyMobile?.trim()) {
    errors.companyMobile = "Organizer mobile is required";
  } else if (!/^[0-9]{7,15}$/.test(data.companyMobile)) {
    errors.companyMobile = "Invalid company mobile number";
  }

  if (!data.companyPhoneNumber?.trim()) {
    errors.companyPhoneNumber = "Organizer phone number is required";
  } else if (!/^[0-9]{7,15}$/.test(data.companyPhoneNumber)) {
    errors.companyPhoneNumber = "Invalid company phone number";
  }

  if (!data.companyCountry) {
    errors.companyCountry = "Country is required";
  }

  if (!data.companyState) {
    errors.companyState = "State is required";
  }

  if (data.companyWebsite?.trim()) {
    const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/;
    if (!urlRegex.test(data.companyWebsite)) {
      errors.companyWebsite = "Invalid website URL";
    }
  }

  if (!isEdit && !data.companyLogo) {
    errors.companyLogo = "Organizer logo is required";
  }

  if (!isEdit && !data.eventBanner) {
    errors.eventBanner = "Event Banner is required";
  }

  if (!data.ticketStartDate) {
    errors.ticketStartDate = " Ticket Start Date is Required";
  }
  if (!data.ticketEndDate) {
    errors.ticketEndDate = " Ticket Start End is Required";
  }
  if (!data.eventStartDate) {
    errors.eventStartDate = " Ticket Event Date is Required";
  }
  if (!data.eventEndDate) {
    errors.eventEndDate = " Ticket Event End is Required";
  }

  if (!data.adminName?.trim()) {
    errors.adminName = "Admin name is required";
  }

  if (!data.adminEmail?.trim()) {
    errors.adminEmail = "Admin email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.adminEmail)) {
    errors.adminEmail = "Invalid admin email";
  }

  if (!isEdit && !data.adminPassword?.trim()) {
    errors.adminPassword = "Password is required";
  } else if (
    data.adminPassword &&
    !/^(?=.*[A-Z])(?=.*\d).{8,}$/.test(data.adminPassword)
  ) {
    errors.adminPassword =
      "Min 8 chars, 1 uppercase letter & 1 number required";
  }

  if (!data.adminMobile?.trim()) {
    errors.adminMobile = "Admin mobile is required";
  } else if (!/^[0-9]{7,15}$/.test(data.adminMobile)) {
    errors.adminMobile = "Invalid admin mobile number";
  }

  if (
    data.companyEmail &&
    data.adminEmail &&
    data.companyEmail.trim().toLowerCase() ===
      data.adminEmail.trim().toLowerCase()
  ) {
    errors.companyEmail = "Must be different from admin email";
    errors.adminEmail = "Must be different from company email";
  }

  if (
    data.companyMobile &&
    data.adminMobile &&
    data.companyMobile === data.adminMobile
  ) {
    errors.companyMobile = "Must be different from admin mobile";
    errors.adminMobile = "Must be different from company mobile";
  }

  if (!Array.isArray(data.eventHighlights) || !data.eventHighlights.length) {
    errors.eventHighlights = "At least one event highlights  is required";
  }

  if (
    !Array.isArray(data.communicationEmails) ||
    !data.communicationEmails.length
  ) {
    errors.communicationEmails = "At least one communication email is required";
  } else {
    const invalidEmail = data.communicationEmails.find(
      (email) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    );

    if (invalidEmail) {
      errors.communicationEmails =
        "One or more communication emails are invalid";
    }
  }
  // --- TICKET DISCOUNTS VALIDATION ---
  if (Array.isArray(data.ticketDiscounts) && data.ticketDiscounts.length > 0) {
    const discountErrors = [];
    const ranges = [];

    data.ticketDiscounts.forEach((tier, index) => {
      const tierError = {};
      const min = Number(tier.minQty);
      const max = Number(tier.maxQty);
      const discount = Number(tier.discountPercentage);

      // 1. Min Qty Validation (Range 1-100)
      if (
        tier.minQty === "" ||
        tier.minQty === null ||
        tier.minQty === undefined
      ) {
        tierError.minQty = "Min quantity is required";
      } else if (isNaN(min) || min < 2 || min > 100) {
        tierError.minQty = "Min quantity must be between 2 and 100";
      }

      // 2. Max Qty Validation (Range 1-100)
      if (
        tier.maxQty === "" ||
        tier.maxQty === null ||
        tier.maxQty === undefined
      ) {
        tierError.maxQty = "Max quantity is required";
      } else if (isNaN(max) || max < 2 || max > 100) {
        tierError.maxQty = "Max quantity must be between 2 and 100";
      }

      // 3. Range check: Min <= Max
      if (!tierError.minQty && !tierError.maxQty && min > max) {
        tierError.minQty = "Min Qty cannot be greater than Max Qty";
      }

      // 4. Discount Percentage Validation (Range 1-100)
      if (
        tier.discountPercentage === "" ||
        tier.discountPercentage === null ||
        tier.discountPercentage === undefined
      ) {
        tierError.discountPercentage = "Discount is required";
      } else if (isNaN(discount) || discount < 1 || discount > 100) {
        tierError.discountPercentage = "Discount must be between 1% and 100%";
      }

      // 5. Duplicate & Overlap Check
      if (!tierError.minQty && !tierError.maxQty) {
        const hasOverlap = ranges.some(
          (r) =>
            (min >= r.min && min <= r.max) ||
            (max >= r.min && max <= r.max) ||
            (min <= r.min && max >= r.max)
        );

        if (hasOverlap) {
          tierError.minQty = "Range overlaps or duplicates an existing tier";
        } else {
          ranges.push({ min, max });
        }
      }

      if (Object.keys(tierError).length > 0) {
        discountErrors[index] = tierError;
      }
    });

    if (discountErrors.length > 0) {
      errors.ticketDiscounts = discountErrors;
    }
  }
  // --- DATE-BASED TICKET PRICE TIERS VALIDATION ---
  if (
    Array.isArray(data.ticketPriceTiers) &&
    data.ticketPriceTiers.length > 0
  ) {
    const priceTierErrors = [];
    const dateRanges = [];
    const titlesSeen = new Set();

    data.ticketPriceTiers.forEach((tier, index) => {
      const tierErr = {};
      const title = tier.title?.trim();
      const p = Number(tier.price);

      if (!title) {
        tierErr.title = "Title is required";
      } else if (titlesSeen.has(title.toLowerCase())) {
        tierErr.title = "Tier title must be unique";
      } else {
        titlesSeen.add(title.toLowerCase());
      }

      if (
        tier.price === "" ||
        tier.price === null ||
        tier.price === undefined
      ) {
        tierErr.price = "Price is required";
      } else if (isNaN(p) || p < 0) {
        tierErr.price = "Price must be at least 0";
      }

      if (!tier.startDate) {
        tierErr.startDate = "Start Date is required";
      }
      if (!tier.endDate) {
        tierErr.endDate = "End Date is required";
      }

      if (tier.startDate && tier.endDate) {
        const sTime = new Date(tier.startDate).getTime();
        const eTime = new Date(tier.endDate).getTime();

        if (sTime > eTime) {
          tierErr.endDate = "End Date cannot be before Start Date";
        }

        const tStart = data.ticketStartDate
          ? new Date(data.ticketStartDate).getTime()
          : null;
        const tEnd = data.ticketEndDate
          ? new Date(data.ticketEndDate).getTime()
          : null;

        if (tStart && sTime < tStart) {
          tierErr.startDate =
            "Cannot start before main Ticket Sales Start Date";
        }
        if (tEnd && eTime > tEnd) {
          tierErr.endDate = "Cannot end after main Ticket Sales End Date";
        }

        if (!tierErr.startDate && !tierErr.endDate) {
          const hasDateOverlap = dateRanges.some(
            (r) =>
              (sTime >= r.sTime && sTime <= r.eTime) ||
              (eTime >= r.sTime && eTime <= r.eTime) ||
              (sTime <= r.sTime && eTime >= r.eTime)
          );

          if (hasDateOverlap) {
            tierErr.startDate = "Date range overlaps with another pricing tier";
          } else {
            dateRanges.push({ sTime, eTime });
          }
        }
      }

      if (Object.keys(tierErr).length > 0) {
        priceTierErrors[index] = tierErr;
      }
    });

    if (priceTierErrors.length > 0) {
      errors.ticketPriceTiers = priceTierErrors;
    }
  }
  // Matches domain names (e.g. youtube.in, instagram.com) or full URLs (https://...)
  const flexibleUrlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;

  // Optional helper to check domain-specific inputs
  const validateSocialLink = (value, platformName) => {
    if (!value || !value.trim()) return null;
    const trimmed = value.trim();

    if (!flexibleUrlRegex.test(trimmed)) {
      return `Invalid ${platformName} URL or domain`;
    }
    return null;
  };

  // Add this block inside your validateOrganizer function:

  if (data.facebookLink?.trim()) {
    const err = validateSocialLink(data.facebookLink, "Facebook");
    if (err) errors.facebookLink = err;
  }

  if (data.instaLink?.trim()) {
    const err = validateSocialLink(data.instaLink, "Instagram");
    if (err) errors.instaLink = err;
  }

  if (data.linkedinLink?.trim()) {
    const err = validateSocialLink(data.linkedinLink, "LinkedIn");
    if (err) errors.linkedinLink = err;
  }

  if (data.youtubeLink?.trim()) {
    const err = validateSocialLink(data.youtubeLink, "YouTube");
    if (err) errors.youtubeLink = err;
  }

  if (data.playStoreLink?.trim()) {
    const err = validateSocialLink(data.playStoreLink, "Play Store");
    if (err) errors.playStoreLink = err;
  }

  if (data.appStoreLink?.trim()) {
    const err = validateSocialLink(data.appStoreLink, "App Store");
    if (err) errors.appStoreLink = err;
  }

  if (!data.termsAndConditions?.trim()) {
    errors.termsAndConditions = "Terms and Conditions URL is required";
  } else if (!flexibleUrlRegex.test(data.termsAndConditions.trim())) {
    errors.termsAndConditions = "Invalid Terms and Conditions URL or domain";
  }

  // --- PRIVACY POLICY VALIDATION (MANDATORY) ---
  if (!data.privacyPolicy?.trim()) {
    errors.privacyPolicy = "Privacy Policy URL is required";
  } else if (!flexibleUrlRegex.test(data.privacyPolicy.trim())) {
    errors.privacyPolicy = "Invalid Privacy Policy URL or domain";
  }
  // --- EMAIL CONFIGURATION VALIDATION ---
  if (!data.emailProvider?.trim()) {
    errors.emailProvider = "Email provider is required";
  }

  if (!data.emailUsername?.trim()) {
    errors.emailUsername = "Username (email) is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.emailUsername.trim())) {
    errors.emailUsername = "Invalid email format";
  }

  if (!data.emailAppPassword?.trim()) {
    errors.emailAppPassword = "App password is required";
  }
  return errors;
};
